import React, { useState } from "react";
import { ModalUpdateContainer } from "./styled";
import { Upload, UploadFile, Avatar, message } from "antd";
import type { UploadProps } from "antd/es/upload";
import type { GetProp } from "antd";
import { ButtonCommon } from "../../../Layout/styled";
import { AVAX_API } from "../../../services/api/indexV2";
import toast from "react-hot-toast";
import { fetchUserProfile } from "../../../store/features/profileSlice";
import { useDispatch } from "../../../store/store";
import Loading from "../../../components/Loading";

type FileType = Parameters<GetProp<UploadProps, "beforeUpload">>[0];

const ModalUpdateProfile = ({ setOpenConfirmModal }: any) => {
  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const [previewUrl, setPreviewUrl] = useState<string | undefined>();
  const [urlAvatar, setUrlAvatar] = useState<string>();
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();

  const handleCustomUpload = async (options: any) => {
    const { file, onSuccess, onError } = options;
    const realFile = file.originFileObj || file;
    const formData = new FormData();
    formData.append("file", realFile);
    try {
      const res: any = await AVAX_API.uploadImage(formData);
      console.log("Uploaded URL:", res?.data?.fileUrl);
      onSuccess("ok");
      if (res?.data?.fileUrl) {
        setUrlAvatar(res?.data?.fileUrl);
      }
    } catch (err) {
      console.error("Upload error", err);
      message.error("Upload failed");
      onError(err);
    }
  };

  const onChange: UploadProps["onChange"] = ({ fileList: newFileList }) => {
    setFileList(newFileList);
    // Update preview
    const file = newFileList[0]?.originFileObj;
    if (file) {
      setPreviewUrl(URL.createObjectURL(file));
    }
  };

  const onPreview = async (file: UploadFile) => {
    let src = file.url as string;
    if (!src && file.originFileObj) {
      src = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.originFileObj as FileType);
        reader.onload = () => resolve(reader.result as string);
      });
    }

    const image = new Image();
    image.src = src;
    const imgWindow = window.open(src);
    imgWindow?.document.write(image.outerHTML);
  };

  const handleUpdateAvatar = async () => {
    setIsLoading(true);
    if (urlAvatar) {
      const params = {
        avatar: urlAvatar,
      };
      const res = await AVAX_API.updateProfile(params);
      if (res?.status === 200) {
        toast.success("Update avatar success");
        dispatch(fetchUserProfile());
        setOpenConfirmModal(false);
        setIsLoading(false);
      } else {
        toast.error("Update fail");
        setIsLoading(false);
      }
    }
  };

  return (
    <ModalUpdateContainer>
      <h2>Edit Profile Picture</h2>
      <div
        className="block-avatar"
        style={{ textAlign: "center", marginBottom: 16 }}
      >
        <p className="current">Current Avatar</p>
        <Avatar
          size={80}
          src={previewUrl || "/assets/images/profile/profile_img_01.png"}
        />
        <p className="update" style={{ marginTop: 8 }}>
          Upload New Image
        </p>
      </div>

      <Upload
        customRequest={handleCustomUpload}
        listType="picture-card"
        fileList={fileList}
        onChange={onChange}
        onPreview={onPreview}
        maxCount={1}
        showUploadList={{ showRemoveIcon: true }}
      >
        {fileList.length < 1 && (
          <img
            src="/assets/images/profile/icn_upload.png"
            alt="Upload"
            style={{ width: 48, height: 48, objectFit: "contain" }}
          />
        )}
      </Upload>
      <ul className="list-buttons">
        <ButtonCommon
          background="#43424A"
          onClick={() => setOpenConfirmModal(false)}
        >
          cancle
        </ButtonCommon>
        <ButtonCommon onClick={() => handleUpdateAvatar()}>
          {isLoading ? <Loading status={true} title="Waiting" /> : "Save"}
        </ButtonCommon>
      </ul>
    </ModalUpdateContainer>
  );
};

export default ModalUpdateProfile;
